"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetHelp = void 0;
const Base_1 = require("./Base");
exports.GetHelp = {
    url: Base_1.URL_BASE + "/GetHelp",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetHelp.js.map